import client from '@sart/client'

export async function getProductImage(displayDetails, imageCategory) {

    if (!displayDetails || !displayDetails.images || displayDetails.images.length === 0) {
      return undefined
    }
    const { links } = displayDetails.images.find(image => image.category === imageCategory);
    
    let link

    if (links && links.length >= 1) {
      //get the first one that has 'SELF'
      for (let imageLink of links) {
        if (imageLink && imageLink.rel === 'self'){
          //just return the first one that matches here
          link =  imageLink
          break
        }
      }
    } else {
      return undefined
    }

    if (!link) {
      return undefined
    }

    let imageResult = await client.retrieveDataFromUrlWithoutTokenRefresh(link.href);

    return imageResult.message
  }

  export async function getWebSafeProductImage(displayDetails, imageCategory) {

    if (!displayDetails || !displayDetails.images || displayDetails.images.length === 0) {
      return undefined
    }
    const { links } = displayDetails.images.find(image => image.category === imageCategory);
    
    let link

    if (links && links.length >= 1) {
      //get the first one that has 'SELF'
      for (let imageLink of links) {
        if (imageLink && imageLink.rel === 'self'){
          //just return the first one that matches here
          link = imageLink
          break
        }
      }
    } else {
      return undefined
    }

    if (!link) {
      return undefined
    }

    let imageResult = await client.retrieveDataFromUrlWithoutTokenRefresh(link.href);
		const imageBuff = new Buffer.from(imageResult.message)
		const imageBase64 = imageBuff.toString('base64')

    return imageBase64
  }